import { render } from "./ScheduleLecture.vue?vue&type=template&id=6f07689a&scoped=true"
import script from "./ScheduleLecture.vue?vue&type=script&lang=js"
export * from "./ScheduleLecture.vue?vue&type=script&lang=js"

import "./ScheduleLecture.vue?vue&type=style&index=0&id=6f07689a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f07689a"]])

export default __exports__